import React, { useContext, useEffect, useRef, useState } from 'react';
import mapboxgl from 'mapbox-gl';
import { makeStyles } from '@material-ui/core/styles';
import { ServiceAreaContext } from '../../Context';
import mapLoad, {
  addLayer,
  addSaveLatLngBoundsButton,
  mapOnLoad,
} from './MapLoad';

mapboxgl.accessToken = process.env.REACT_APP_MAPBOX_TOKEN;

let map = null;

const useStyles = makeStyles(() => ({
  mapContainer: {
    height: 'calc(100vh - 126px)',
  },
  popUpContainer: {
    height: '200px',
  },
}));

const clickOnLayer = (e, vehicle, serviceArea, classes) => {
  const coordinates = e.lngLat;
  new mapboxgl.Popup({
    closeOnMove: true,
    closeOnClick: true,
    className: classes.popUpContainer,
  })
    .setLngLat(coordinates)
    .setHTML(
      `<b>${vehicle}</b>
      <hr />
      <span>${serviceArea.join(', ')}</span>`,
    )
    .setMaxWidth('300px')
    .addTo(map);
};

const MapView = () => {
  const { data, selectedVehicles } = useContext(ServiceAreaContext);
  const classes = useStyles();
  const mapperRef = useRef(null);
  const [mapLoaded, setMapLoaded] = useState(false);

  useEffect(() => {
    if (map) {
      map.remove();
    }
  }, []);
  // Effect for the initial loading map
  useEffect(() => {
    if (mapperRef) {
      map = mapLoad(mapperRef);
      mapOnLoad(map);
      addSaveLatLngBoundsButton(map);
    }
  }, []);
  // Effect for adding layer and click event
  useEffect(() => {
    if (map && Object.keys(data).length === selectedVehicles.length) {
      Object.keys(data).forEach((vehicle) => {
        const serviceArea = data[vehicle].service_areas.map(
          (service_area) => service_area.postal_code,
        );
        if (serviceArea.length > 0) {
          map.on('load', () => {
            if (!map.getLayer(`us-zip-code-fill-layer-${vehicle}`)) {
              addLayer(map, vehicle, serviceArea);
              map.on('click', `us-zip-code-fill-layer-${vehicle}`, (e) =>
                clickOnLayer(e, vehicle, serviceArea, classes),
              );
            }
          });
        }
      });
    }
  }, []);
  // Effect for the checkbox on change
  useEffect(() => {
    if (mapLoaded) {
      Object.keys(data).forEach((vehicle) => {
        if (map.getLayer(`us-zip-code-fill-layer-${vehicle}`)) {
          map.removeLayer(`us-zip-code-fill-layer-${vehicle}`);
        }
      });
      selectedVehicles.forEach((vehicle) => {
        const serviceArea = data[vehicle].service_areas.map(
          (service_area) => service_area.postal_code,
        );
        if (serviceArea.length > 0) {
          if (!map.getLayer(`us-zip-code-fill-layer-${vehicle}`)) {
            addLayer(map, vehicle, serviceArea);
          }
        }
      });
    } else {
      setMapLoaded(true);
    }
  }, [selectedVehicles]);
  return <div ref={mapperRef} className={classes.mapContainer} />;
};

export default MapView;
